import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupExclude: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-exclude"><path d="M8.75 2.75H21.25V15.25H8.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 8.75H15.25V21.25H2.75V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBooleanGroupExclude;
